import { render, staticRenderFns } from "./DscUI.vue?vue&type=template&id=743fa609&scoped=true&"
import script from "./DscUI.vue?vue&type=script&lang=js&"
export * from "./DscUI.vue?vue&type=script&lang=js&"
import style0 from "./DscUI.vue?vue&type=style&index=0&id=743fa609&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743fa609",
  null
  
)

export default component.exports